import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-ContentRoles', [
  'addButton',
  'rolesList',
  'titleInput',
  'descriptionInput',
  'saveButton',
  'deleteDialog',
  'loadingSpinner',
  'emptyState',
]);
